import { createElement, Component } from 'react';
import { isEqual, omit } from 'lodash';

var FastCommentsAPINotificationObjectType;
(function (FastCommentsAPINotificationObjectType) {
    FastCommentsAPINotificationObjectType[FastCommentsAPINotificationObjectType["Comment"] = 0] = "Comment";
    FastCommentsAPINotificationObjectType[FastCommentsAPINotificationObjectType["Profile"] = 1] = "Profile";
    FastCommentsAPINotificationObjectType[FastCommentsAPINotificationObjectType["Tenant"] = 2] = "Tenant";
})(FastCommentsAPINotificationObjectType || (FastCommentsAPINotificationObjectType = {}));
var FastCommentsAPINotificationType;
(function (FastCommentsAPINotificationType) {
    /** If someone replied to you. **/
    FastCommentsAPINotificationType[FastCommentsAPINotificationType["RepliedToMe"] = 0] = "RepliedToMe";
    /** If someone replied anywhere in a thread (even children of children) of a thread you commented on. **/
    FastCommentsAPINotificationType[FastCommentsAPINotificationType["RepliedTransientChild"] = 1] = "RepliedTransientChild";
    /** If your comment was up-voted. **/
    FastCommentsAPINotificationType[FastCommentsAPINotificationType["VotedMyComment"] = 2] = "VotedMyComment";
    /** If a new comment is left on the root of a page you're subscribed to. **/
    FastCommentsAPINotificationType[FastCommentsAPINotificationType["SubscriptionReplyRoot"] = 3] = "SubscriptionReplyRoot";
    /** If someone commented on your profile. **/
    FastCommentsAPINotificationType[FastCommentsAPINotificationType["CommentedOnProfile"] = 4] = "CommentedOnProfile";
    /** If you have a DM. **/
    FastCommentsAPINotificationType[FastCommentsAPINotificationType["DirectMessage"] = 5] = "DirectMessage";
    /** TrialLimits is for tenant users only. **/
    FastCommentsAPINotificationType[FastCommentsAPINotificationType["TrialLimits"] = 6] = "TrialLimits";
    /** If you were @mentioned. **/
    FastCommentsAPINotificationType[FastCommentsAPINotificationType["Mentioned"] = 7] = "Mentioned";
})(FastCommentsAPINotificationType || (FastCommentsAPINotificationType = {}));
//# sourceMappingURL=notifications.js.map

var FastCommentsAPIUserDigestEmailFrequency;
(function (FastCommentsAPIUserDigestEmailFrequency) {
    FastCommentsAPIUserDigestEmailFrequency[FastCommentsAPIUserDigestEmailFrequency["Disabled"] = -1] = "Disabled";
    FastCommentsAPIUserDigestEmailFrequency[FastCommentsAPIUserDigestEmailFrequency["Daily"] = 0] = "Daily";
    FastCommentsAPIUserDigestEmailFrequency[FastCommentsAPIUserDigestEmailFrequency["Weekly"] = 1] = "Weekly";
    FastCommentsAPIUserDigestEmailFrequency[FastCommentsAPIUserDigestEmailFrequency["Monthly"] = 2] = "Monthly";
})(FastCommentsAPIUserDigestEmailFrequency || (FastCommentsAPIUserDigestEmailFrequency = {}));
//# sourceMappingURL=tenant-users.js.map

var TenantPaymentFrequency;
(function (TenantPaymentFrequency) {
    TenantPaymentFrequency[TenantPaymentFrequency["Monthly"] = 0] = "Monthly";
    TenantPaymentFrequency[TenantPaymentFrequency["Annually"] = 1] = "Annually";
})(TenantPaymentFrequency || (TenantPaymentFrequency = {}));
//# sourceMappingURL=tenants.js.map

var FastCommentsLocale;
(function (FastCommentsLocale) {
    FastCommentsLocale["zh_cn"] = "zh_cn";
    FastCommentsLocale["zh_tw"] = "zh_tw";
    FastCommentsLocale["hr_hr"] = "hr_hr";
    FastCommentsLocale["en_us"] = "en_us";
    FastCommentsLocale["fr_fr"] = "fr_fr";
    FastCommentsLocale["de_de"] = "de_de";
    FastCommentsLocale["it_it"] = "it_it";
    FastCommentsLocale["ja_jp"] = "ja_jp";
    FastCommentsLocale["pl_pl"] = "pl_pl";
    FastCommentsLocale["pt_br"] = "pt_br";
    FastCommentsLocale["ru_ru"] = "ru_ru";
    FastCommentsLocale["es_es"] = "es_es";
    FastCommentsLocale["tr_tr"] = "tr_tr";
})(FastCommentsLocale || (FastCommentsLocale = {}));
var FastCommentsSiteType;
(function (FastCommentsSiteType) {
    FastCommentsSiteType[FastCommentsSiteType["Unknown"] = 0] = "Unknown";
    FastCommentsSiteType[FastCommentsSiteType["WordPress"] = 1] = "WordPress";
})(FastCommentsSiteType || (FastCommentsSiteType = {}));
var NotificationType;
(function (NotificationType) {
    NotificationType[NotificationType["RepliedToMe"] = 0] = "RepliedToMe";
    NotificationType[NotificationType["RepliedTransientChild"] = 1] = "RepliedTransientChild";
    NotificationType[NotificationType["VotedMyComment"] = 2] = "VotedMyComment";
    NotificationType[NotificationType["SubscriptionReplyRoot"] = 3] = "SubscriptionReplyRoot";
    NotificationType[NotificationType["CommentedOnProfile"] = 4] = "CommentedOnProfile";
    NotificationType[NotificationType["DirectMessage"] = 5] = "DirectMessage";
    NotificationType[NotificationType["Mentioned"] = 7] = "Mentioned";
})(NotificationType || (NotificationType = {}));
var NotificationObjectType;
(function (NotificationObjectType) {
    NotificationObjectType[NotificationObjectType["Comment"] = 0] = "Comment";
    NotificationObjectType[NotificationObjectType["Profile"] = 1] = "Profile";
})(NotificationObjectType || (NotificationObjectType = {}));
var VoteStyle;
(function (VoteStyle) {
    VoteStyle[VoteStyle["UpDown"] = 0] = "UpDown";
    VoteStyle[VoteStyle["Heart"] = 1] = "Heart";
})(VoteStyle || (VoteStyle = {}));
//# sourceMappingURL=constants.js.map

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

// A type of promise-like that resolves synchronously and supports only one observer
const _Pact = /*#__PURE__*/(function() {
	function _Pact() {}
	_Pact.prototype.then = function(onFulfilled, onRejected) {
		const result = new _Pact();
		const state = this.s;
		if (state) {
			const callback = state & 1 ? onFulfilled : onRejected;
			if (callback) {
				try {
					_settle(result, 1, callback(this.v));
				} catch (e) {
					_settle(result, 2, e);
				}
				return result;
			} else {
				return this;
			}
		}
		this.o = function(_this) {
			try {
				const value = _this.v;
				if (_this.s & 1) {
					_settle(result, 1, onFulfilled ? onFulfilled(value) : value);
				} else if (onRejected) {
					_settle(result, 1, onRejected(value));
				} else {
					_settle(result, 2, value);
				}
			} catch (e) {
				_settle(result, 2, e);
			}
		};
		return result;
	};
	return _Pact;
})();

// Settles a pact synchronously
function _settle(pact, state, value) {
	if (!pact.s) {
		if (value instanceof _Pact) {
			if (value.s) {
				if (state & 1) {
					state = value.s;
				}
				value = value.v;
			} else {
				value.o = _settle.bind(null, pact, state);
				return;
			}
		}
		if (value && value.then) {
			value.then(_settle.bind(null, pact, state), _settle.bind(null, pact, 2));
			return;
		}
		pact.s = state;
		pact.v = value;
		const observer = pact.o;
		if (observer) {
			observer(pact);
		}
	}
}

const _iteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))) : "@@iterator";

const _asyncIteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator"))) : "@@asyncIterator";

// Asynchronously implement a switch statement
function _switch(discriminant, cases) {
	var dispatchIndex = -1;
	var awaitBody;
	outer: {
		for (var i = 0; i < cases.length; i++) {
			var test = cases[i][0];
			if (test) {
				var testValue = test();
				if (testValue && testValue.then) {
					break outer;
				}
				if (testValue === discriminant) {
					dispatchIndex = i;
					break;
				}
			} else {
				// Found the default case, set it as the pending dispatch case
				dispatchIndex = i;
			}
		}
		if (dispatchIndex !== -1) {
			do {
				var body = cases[dispatchIndex][1];
				while (!body) {
					dispatchIndex++;
					body = cases[dispatchIndex][1];
				}
				var result = body();
				if (result && result.then) {
					awaitBody = true;
					break outer;
				}
				var fallthroughCheck = cases[dispatchIndex][2];
				dispatchIndex++;
			} while (fallthroughCheck && !fallthroughCheck());
			return result;
		}
	}
	const pact = new _Pact();
	const reject = _settle.bind(null, pact, 2);
	(awaitBody ? result.then(_resumeAfterBody) : testValue.then(_resumeAfterTest)).then(void 0, reject);
	return pact;
	function _resumeAfterTest(value) {
		for (;;) {
			if (value === discriminant) {
				dispatchIndex = i;
				break;
			}
			if (++i === cases.length) {
				if (dispatchIndex !== -1) {
					break;
				} else {
					_settle(pact, 1, result);
					return;
				}
			}
			test = cases[i][0];
			if (test) {
				value = test();
				if (value && value.then) {
					value.then(_resumeAfterTest).then(void 0, reject);
					return;
				}
			} else {
				dispatchIndex = i;
			}
		}
		do {
			var body = cases[dispatchIndex][1];
			while (!body) {
				dispatchIndex++;
				body = cases[dispatchIndex][1];
			}
			var result = body();
			if (result && result.then) {
				result.then(_resumeAfterBody).then(void 0, reject);
				return;
			}
			var fallthroughCheck = cases[dispatchIndex][2];
			dispatchIndex++;
		} while (fallthroughCheck && !fallthroughCheck());
		_settle(pact, 1, result);
	}
	function _resumeAfterBody(result) {
		for (;;) {
			var fallthroughCheck = cases[dispatchIndex][2];
			if (!fallthroughCheck || fallthroughCheck()) {
				break;
			}
			dispatchIndex++;
			var body = cases[dispatchIndex][1];
			while (!body) {
				dispatchIndex++;
				body = cases[dispatchIndex][1];
			}
			result = body();
			if (result && result.then) {
				result.then(_resumeAfterBody).then(void 0, reject);
				return;
			}
		}
		_settle(pact, 1, result);
	}
}

// Asynchronously call a function and send errors to recovery continuation
function _catch(body, recover) {
	try {
		var result = body();
	} catch(e) {
		return recover(e);
	}
	if (result && result.then) {
		return result.then(void 0, recover);
	}
	return result;
}

var ScriptLoader = /*#__PURE__*/function () {
  function ScriptLoader() {
    this.scriptLoadingStarted = false;
  }

  var _proto = ScriptLoader.prototype;

  _proto.insertScript = function insertScript(src, id, parentElement) {
    try {
      var _this2 = this;

      if (!_this2.scriptLoadingStarted) {
        _this2.scriptLoadPromiseHandlers = [];
        _this2.scriptLoadingStarted = true;
        return Promise.resolve(new Promise(function (resolve, reject) {
          var script = window.document.createElement('script');
          script.async = true;
          script.src = src;
          script.id = id;
          parentElement.appendChild(script);

          _this2.scriptLoadPromiseHandlers.push([resolve, reject]);

          script.addEventListener('load', function () {
            _this2.scriptLoadPromiseHandlers.forEach(function (handler) {
              return handler[0]();
            });

            _this2.scriptLoadPromiseHandlers = [];
          });
          script.addEventListener('error', function () {
            _this2.scriptLoadPromiseHandlers.forEach(function (handler) {
              return handler[1]();
            });

            _this2.scriptLoadPromiseHandlers = [];
          });
        }));
      } else {
        return Promise.resolve(new Promise(function (resolve, reject) {
          _this2.scriptLoadPromiseHandlers.push([resolve, reject]);
        }));
      }
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return ScriptLoader;
}();

var LoadStatus;

(function (LoadStatus) {
  LoadStatus[LoadStatus["Started"] = 0] = "Started";
  LoadStatus[LoadStatus["ScriptLoaded"] = 1] = "ScriptLoaded";
  LoadStatus[LoadStatus["Done"] = 2] = "Done";
  LoadStatus[LoadStatus["Error"] = 3] = "Error";
})(LoadStatus || (LoadStatus = {}));

var FastCommentsCommentCountWidget = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FastCommentsCommentCountWidget, _React$Component);

  function FastCommentsCommentCountWidget(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      status: LoadStatus.Started,
      widgetId: null
    };
    return _this;
  }

  var _proto = FastCommentsCommentCountWidget.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.setState({
      status: LoadStatus.Started,
      widgetId: "fastcomments-count-widget-" + Math.random() + "-" + Date.now()
    });
    this.lastWidgetInstance = null;
    return this.loadInstance();
  };

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return !isEqual(this.props, nextProps);
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.state.status === LoadStatus.ScriptLoaded) {
      return this.reset();
    } else {
      return this.loadInstance();
    }
  };

  _proto.loadInstance = function loadInstance() {
    try {
      var _this3 = this;

      return Promise.resolve(new Promise(function (resolve, reject) {
        try {
          var _temp5 = _switch(_this3.state.status, [[function () {
            return LoadStatus.Started;
          }, function () {
            var _temp3 = _catch(function () {
              function _temp2() {
                _this3.setState({
                  status: LoadStatus.ScriptLoaded
                });

                _this3.forceUpdate();

                resolve();
              }

              var _temp = function () {
                if (window && !window.FastCommentsCommentCount) {
                  var src = _this3.props.region === 'eu' ? 'https://cdn-eu.fastcomments.com/js/widget-comment-count.min.js' : 'https://cdn.fastcomments.com/js/widget-comment-count.min.js';
                  return Promise.resolve(FastCommentsCommentCountWidget.widgetLoader.insertScript(src, 'fastcomments-count-widget-script', window.document.body)).then(function () {});
                }
              }();

              return _temp && _temp.then ? _temp.then(_temp2) : _temp2(_temp);
            }, function (e) {
              console.error('FastComments Script Load Failure', e);

              _this3.setState({
                status: LoadStatus.Error
              });

              _this3.forceUpdate();

              reject();
            });

            if (_temp3 && _temp3.then) return _temp3.then(function () {});
          }], [function () {
            return LoadStatus.ScriptLoaded;
          }, function () {
            _this3.instantiateWidget();

            _this3.setState({
              status: LoadStatus.Done
            });

            resolve();
          }], [void 0, function () {
            resolve();
          }]]);

          return Promise.resolve(_temp5 && _temp5.then ? _temp5.then(function () {}) : void 0);
        } catch (e) {
          return Promise.reject(e);
        }
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.reset = function reset() {
    if (this.lastWidgetInstance) {
      this.lastWidgetInstance.update(this.props);
    } else {
      this.instantiateWidget();
    }
  };

  _proto.instantiateWidget = function instantiateWidget() {
    if (this.state.widgetId) {
      var element = document.getElementById(this.state.widgetId);

      if (element) {
        this.lastWidgetInstance = window.FastCommentsCommentCount(element, this.props);
      }
    }
  };

  _proto.render = function render() {
    return createElement("div", null, this.state.widgetId ? createElement("div", {
      id: this.state.widgetId
    }, this.state.status === LoadStatus.Error ? 'Oh no! The comment count could not be loaded.' : '') : '');
  };

  return FastCommentsCommentCountWidget;
}(Component);
FastCommentsCommentCountWidget.widgetLoader = new ScriptLoader();

var LoadStatus$1;

(function (LoadStatus) {
  LoadStatus[LoadStatus["Started"] = 0] = "Started";
  LoadStatus[LoadStatus["ScriptLoaded"] = 1] = "ScriptLoaded";
  LoadStatus[LoadStatus["Done"] = 2] = "Done";
  LoadStatus[LoadStatus["Error"] = 3] = "Error";
})(LoadStatus$1 || (LoadStatus$1 = {}));

var FastCommentsCommentWidget = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FastCommentsCommentWidget, _React$Component);

  function FastCommentsCommentWidget(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      status: LoadStatus$1.Started,
      widgetId: null
    };
    return _this;
  }

  var _proto = FastCommentsCommentWidget.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.setState({
      status: LoadStatus$1.Started,
      widgetId: "fastcomments-widget-" + Math.random() + "-" + Date.now()
    });
    this.lastWidgetInstance = null;
    return this.loadInstance();
  };

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return !isEqual(this.props, nextProps);
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.state.status === LoadStatus$1.ScriptLoaded) {
      return this.reset();
    } else {
      return this.loadInstance();
    }
  };

  _proto.loadInstance = function loadInstance() {
    try {
      var _this3 = this;

      return Promise.resolve(new Promise(function (resolve, reject) {
        try {
          var _temp5 = _switch(_this3.state.status, [[function () {
            return LoadStatus$1.Started;
          }, function () {
            var _temp3 = _catch(function () {
              function _temp2() {
                _this3.setState({
                  status: LoadStatus$1.ScriptLoaded
                });

                _this3.forceUpdate();

                resolve();
              }

              var _temp = function () {
                if (window && !window.FastCommentsUI) {
                  var src = _this3.props.region === 'eu' ? 'https://cdn-eu.fastcomments.com/js/embed-v2.min.js' : 'https://cdn.fastcomments.com/js/embed-v2.min.js';
                  return Promise.resolve(FastCommentsCommentWidget.widgetLoader.insertScript(src, 'fastcomments-widget-script', window.document.body)).then(function () {});
                }
              }();

              return _temp && _temp.then ? _temp.then(_temp2) : _temp2(_temp);
            }, function (e) {
              console.error('FastComments Script Load Failure', e);

              _this3.setState({
                status: LoadStatus$1.Error
              });

              _this3.forceUpdate();

              reject();
            });

            if (_temp3 && _temp3.then) return _temp3.then(function () {});
          }], [function () {
            return LoadStatus$1.ScriptLoaded;
          }, function () {
            _this3.instantiateWidget();

            _this3.setState({
              status: LoadStatus$1.Done
            });

            resolve();
          }], [void 0, function () {
            resolve();
          }]]);

          return Promise.resolve(_temp5 && _temp5.then ? _temp5.then(function () {}) : void 0);
        } catch (e) {
          return Promise.reject(e);
        }
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.reset = function reset() {
    if (this.lastWidgetInstance) {
      this.lastWidgetInstance.update(this.props);
    } else {
      this.instantiateWidget();
    }
  };

  _proto.instantiateWidget = function instantiateWidget() {
    if (this.state.widgetId) {
      var element = document.getElementById(this.state.widgetId);

      if (element) {
        this.lastWidgetInstance = window.FastCommentsUI(element, this.props);
      }
    }
  };

  _proto.render = function render() {
    return createElement("div", null, this.state.widgetId ? createElement("div", {
      id: this.state.widgetId
    }, this.state.status === LoadStatus$1.Error ? 'Oh no! The comments section could not be loaded.' : '') : '');
  };

  return FastCommentsCommentWidget;
}(Component);
FastCommentsCommentWidget.widgetLoader = new ScriptLoader();

var LoadStatus$2;

(function (LoadStatus) {
  LoadStatus[LoadStatus["Started"] = 0] = "Started";
  LoadStatus[LoadStatus["ScriptLoaded"] = 1] = "ScriptLoaded";
  LoadStatus[LoadStatus["Done"] = 2] = "Done";
  LoadStatus[LoadStatus["Error"] = 3] = "Error";
})(LoadStatus$2 || (LoadStatus$2 = {}));

var FastCommentsCollabChatWidget = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FastCommentsCollabChatWidget, _React$Component);

  function FastCommentsCollabChatWidget(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      status: LoadStatus$2.Started,
      widgetId: null
    };
    return _this;
  }

  var _proto = FastCommentsCollabChatWidget.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.setState({
      status: LoadStatus$2.Started,
      widgetId: "fastcomments-collab-chat-widget-" + Math.random() + "-" + Date.now()
    });
    this.lastWidgetInstance = null;
    return this.loadInstance();
  };

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return !isEqual(this.props, nextProps);
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.state.status === LoadStatus$2.ScriptLoaded) {
      return this.reset();
    } else {
      return this.loadInstance();
    }
  };

  _proto.loadInstance = function loadInstance() {
    try {
      var _this3 = this;

      return Promise.resolve(new Promise(function (resolve, reject) {
        try {
          var _temp5 = _switch(_this3.state.status, [[function () {
            return LoadStatus$2.Started;
          }, function () {
            var _temp3 = _catch(function () {
              function _temp2() {
                _this3.setState({
                  status: LoadStatus$2.ScriptLoaded
                });

                _this3.forceUpdate();

                resolve();
              }

              var _temp = function () {
                if (window && !window.FastCommentsCollabChat) {
                  var src = _this3.props.region === 'eu' ? 'https://cdn-eu.fastcomments.com/js/embed-collab-chat.min.js' : 'https://cdn.fastcomments.com/js/embed-collab-chat.min.js';
                  return Promise.resolve(FastCommentsCollabChatWidget.widgetLoader.insertScript(src, 'fastcomments-collab-chat-script', window.document.body)).then(function () {});
                }
              }();

              return _temp && _temp.then ? _temp.then(_temp2) : _temp2(_temp);
            }, function (e) {
              console.error('FastComments Script Load Failure', e);

              _this3.setState({
                status: LoadStatus$2.Error
              });

              _this3.forceUpdate();

              reject();
            });

            if (_temp3 && _temp3.then) return _temp3.then(function () {});
          }], [function () {
            return LoadStatus$2.ScriptLoaded;
          }, function () {
            _this3.instantiateWidget();

            _this3.setState({
              status: LoadStatus$2.Done
            });

            resolve();
          }], [void 0, function () {
            resolve();
          }]]);

          return Promise.resolve(_temp5 && _temp5.then ? _temp5.then(function () {}) : void 0);
        } catch (e) {
          return Promise.reject(e);
        }
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.reset = function reset() {
    if (this.lastWidgetInstance) {
      this.lastWidgetInstance.update(this.props);
    } else {
      this.instantiateWidget();
    }
  };

  _proto.instantiateWidget = function instantiateWidget() {
    if (this.state.widgetId) {
      var element = this.props.targetRef;

      if (element && element.current) {
        var clonedProps = _extends({}, omit(this.props, 'targetRef'));

        this.lastWidgetInstance = window.FastCommentsCollabChat(element.current, clonedProps);
      }
    }
  };

  _proto.render = function render() {
    return createElement("div", null, this.state.widgetId ? createElement("div", {
      id: this.state.widgetId
    }, this.state.status === LoadStatus$2.Error ? 'Oh no! The comments section could not be loaded.' : '') : '');
  };

  return FastCommentsCollabChatWidget;
}(Component);
FastCommentsCollabChatWidget.widgetLoader = new ScriptLoader();

var LoadStatus$3;

(function (LoadStatus) {
  LoadStatus[LoadStatus["Started"] = 0] = "Started";
  LoadStatus[LoadStatus["ScriptLoaded"] = 1] = "ScriptLoaded";
  LoadStatus[LoadStatus["Done"] = 2] = "Done";
  LoadStatus[LoadStatus["Error"] = 3] = "Error";
})(LoadStatus$3 || (LoadStatus$3 = {}));

var FastCommentsImageChatWidget = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FastCommentsImageChatWidget, _React$Component);

  function FastCommentsImageChatWidget(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      status: LoadStatus$3.Started,
      widgetId: null
    };
    return _this;
  }

  var _proto = FastCommentsImageChatWidget.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.setState({
      status: LoadStatus$3.Started,
      widgetId: "fastcomments-image-chat-widget-" + Math.random() + "-" + Date.now()
    });
    this.lastWidgetInstance = null;
    return this.loadInstance();
  };

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return !isEqual(this.props, nextProps);
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.state.status === LoadStatus$3.ScriptLoaded) {
      return this.reset();
    } else {
      return this.loadInstance();
    }
  };

  _proto.loadInstance = function loadInstance() {
    try {
      var _this3 = this;

      return Promise.resolve(new Promise(function (resolve, reject) {
        try {
          var _temp5 = _switch(_this3.state.status, [[function () {
            return LoadStatus$3.Started;
          }, function () {
            var _temp3 = _catch(function () {
              function _temp2() {
                _this3.setState({
                  status: LoadStatus$3.ScriptLoaded
                });

                _this3.forceUpdate();

                resolve();
              }

              var _temp = function () {
                if (window && !window.FastCommentsImageChat) {
                  var src = _this3.props.region === 'eu' ? 'https://cdn-eu.fastcomments.com/js/embed-image-chat.min.js' : 'https://cdn.fastcomments.com/js/embed-image-chat.min.js';
                  return Promise.resolve(FastCommentsImageChatWidget.widgetLoader.insertScript(src, 'fastcomments-image-chat-script', window.document.body)).then(function () {});
                }
              }();

              return _temp && _temp.then ? _temp.then(_temp2) : _temp2(_temp);
            }, function (e) {
              console.error('FastComments Script Load Failure', e);

              _this3.setState({
                status: LoadStatus$3.Error
              });

              _this3.forceUpdate();

              reject();
            });

            if (_temp3 && _temp3.then) return _temp3.then(function () {});
          }], [function () {
            return LoadStatus$3.ScriptLoaded;
          }, function () {
            _this3.instantiateWidget();

            _this3.setState({
              status: LoadStatus$3.Done
            });

            resolve();
          }], [void 0, function () {
            resolve();
          }]]);

          return Promise.resolve(_temp5 && _temp5.then ? _temp5.then(function () {}) : void 0);
        } catch (e) {
          return Promise.reject(e);
        }
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.reset = function reset() {
    if (this.lastWidgetInstance) {
      this.lastWidgetInstance.update(this.props);
    } else {
      this.instantiateWidget();
    }
  };

  _proto.instantiateWidget = function instantiateWidget() {
    if (this.state.widgetId) {
      var element = this.props.targetRef;

      if (element && element.current) {
        var clonedProps = _extends({}, omit(this.props, 'targetRef'));

        this.lastWidgetInstance = window.FastCommentsImageChat(element.current, clonedProps);
      }
    }
  };

  _proto.render = function render() {
    return createElement("div", null, this.state.widgetId ? createElement("div", {
      id: this.state.widgetId
    }, this.state.status === LoadStatus$3.Error ? 'Oh no! The comments section could not be loaded.' : '') : '');
  };

  return FastCommentsImageChatWidget;
}(Component);
FastCommentsImageChatWidget.widgetLoader = new ScriptLoader();

var LoadStatus$4;

(function (LoadStatus) {
  LoadStatus[LoadStatus["Started"] = 0] = "Started";
  LoadStatus[LoadStatus["ScriptLoaded"] = 1] = "ScriptLoaded";
  LoadStatus[LoadStatus["Done"] = 2] = "Done";
  LoadStatus[LoadStatus["Error"] = 3] = "Error";
})(LoadStatus$4 || (LoadStatus$4 = {}));

var FastCommentsLiveChatWidget = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FastCommentsLiveChatWidget, _React$Component);

  function FastCommentsLiveChatWidget(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      status: LoadStatus$4.Started,
      widgetId: null
    };
    return _this;
  }

  var _proto = FastCommentsLiveChatWidget.prototype;

  _proto.componentDidMount = function componentDidMount() {
    console.log('refs', this.refs);
    this.setState({
      status: LoadStatus$4.Started,
      widgetId: "fastcomments-live-chat-widget-" + Math.random() + "-" + Date.now()
    });
    this.lastWidgetInstance = null;
    return this.loadInstance();
  };

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return !isEqual(this.props, nextProps);
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.state.status === LoadStatus$4.ScriptLoaded) {
      return this.reset();
    } else {
      return this.loadInstance();
    }
  };

  _proto.loadInstance = function loadInstance() {
    try {
      var _this3 = this;

      return Promise.resolve(new Promise(function (resolve, reject) {
        try {
          var _temp5 = _switch(_this3.state.status, [[function () {
            return LoadStatus$4.Started;
          }, function () {
            var _temp3 = _catch(function () {
              function _temp2() {
                _this3.setState({
                  status: LoadStatus$4.ScriptLoaded
                });

                _this3.forceUpdate();

                resolve();
              }

              var _temp = function () {
                if (window && !window.FastCommentsLiveChat) {
                  var src = _this3.props.region === 'eu' ? 'https://cdn-eu.fastcomments.com/js/embed-live-chat.min.js' : 'https://cdn.fastcomments.com/js/embed-live-chat.min.js';
                  return Promise.resolve(FastCommentsLiveChatWidget.widgetLoader.insertScript(src, 'fastcomments-live-chat-script', window.document.body)).then(function () {});
                }
              }();

              return _temp && _temp.then ? _temp.then(_temp2) : _temp2(_temp);
            }, function (e) {
              console.error('FastComments Script Load Failure', e);

              _this3.setState({
                status: LoadStatus$4.Error
              });

              _this3.forceUpdate();

              reject();
            });

            if (_temp3 && _temp3.then) return _temp3.then(function () {});
          }], [function () {
            return LoadStatus$4.ScriptLoaded;
          }, function () {
            _this3.instantiateWidget();

            _this3.setState({
              status: LoadStatus$4.Done
            });

            resolve();
          }], [void 0, function () {
            resolve();
          }]]);

          return Promise.resolve(_temp5 && _temp5.then ? _temp5.then(function () {}) : void 0);
        } catch (e) {
          return Promise.reject(e);
        }
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.reset = function reset() {
    if (this.lastWidgetInstance) {
      this.lastWidgetInstance.update(this.props);
    } else {
      this.instantiateWidget();
    }
  };

  _proto.instantiateWidget = function instantiateWidget() {
    if (this.state.widgetId) {
      var element = document.getElementById(this.state.widgetId);

      if (element) {
        this.lastWidgetInstance = window.FastCommentsLiveChat(element, this.props);
      }
    }
  };

  _proto.render = function render() {
    return createElement("div", null, this.state.widgetId ? createElement("div", {
      id: this.state.widgetId
    }, this.state.status === LoadStatus$4.Error ? 'Oh no! The comments section could not be loaded.' : '') : '');
  };

  return FastCommentsLiveChatWidget;
}(Component);
FastCommentsLiveChatWidget.widgetLoader = new ScriptLoader();

var LoadStatus$5;

(function (LoadStatus) {
  LoadStatus[LoadStatus["Started"] = 0] = "Started";
  LoadStatus[LoadStatus["ScriptLoaded"] = 1] = "ScriptLoaded";
  LoadStatus[LoadStatus["Done"] = 2] = "Done";
  LoadStatus[LoadStatus["Error"] = 3] = "Error";
})(LoadStatus$5 || (LoadStatus$5 = {}));

var FastCommentsUserActivityFeedWidget = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FastCommentsUserActivityFeedWidget, _React$Component);

  function FastCommentsUserActivityFeedWidget(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      status: LoadStatus$5.Started,
      widgetId: null
    };
    return _this;
  }

  var _proto = FastCommentsUserActivityFeedWidget.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.setState({
      status: LoadStatus$5.Started,
      widgetId: "fastcomments-widget-" + Math.random() + "-" + Date.now()
    });
    this.lastWidgetInstance = null;
    return this.loadInstance();
  };

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return !isEqual(this.props, nextProps);
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.state.status === LoadStatus$5.ScriptLoaded) {
      return this.reset();
    } else {
      return this.loadInstance();
    }
  };

  _proto.loadInstance = function loadInstance() {
    try {
      var _this3 = this;

      return Promise.resolve(new Promise(function (resolve, reject) {
        try {
          var _temp5 = _switch(_this3.state.status, [[function () {
            return LoadStatus$5.Started;
          }, function () {
            var _temp3 = _catch(function () {
              function _temp2() {
                _this3.setState({
                  status: LoadStatus$5.ScriptLoaded
                });

                _this3.forceUpdate();

                resolve();
              }

              var _temp = function () {
                if (window && !window.FastCommentsUserActivity) {
                  var src = _this3.props.region === 'eu' ? 'https://cdn-eu.fastcomments.com/js/embed-user-activity.min.js' : 'https://cdn.fastcomments.com/js/embed-user-activity.min.js';
                  return Promise.resolve(FastCommentsUserActivityFeedWidget.widgetLoader.insertScript(src, 'fastcomments-widget-script', window.document.body)).then(function () {});
                }
              }();

              return _temp && _temp.then ? _temp.then(_temp2) : _temp2(_temp);
            }, function (e) {
              console.error('FastComments Script Load Failure', e);

              _this3.setState({
                status: LoadStatus$5.Error
              });

              _this3.forceUpdate();

              reject();
            });

            if (_temp3 && _temp3.then) return _temp3.then(function () {});
          }], [function () {
            return LoadStatus$5.ScriptLoaded;
          }, function () {
            _this3.instantiateWidget();

            _this3.setState({
              status: LoadStatus$5.Done
            });

            resolve();
          }], [void 0, function () {
            resolve();
          }]]);

          return Promise.resolve(_temp5 && _temp5.then ? _temp5.then(function () {}) : void 0);
        } catch (e) {
          return Promise.reject(e);
        }
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.reset = function reset() {
    if (this.lastWidgetInstance) {
      this.lastWidgetInstance.update(_extends({}, this.props));
    } else {
      this.instantiateWidget();
    }
  };

  _proto.instantiateWidget = function instantiateWidget() {
    var _this4 = this;

    if (this.state.widgetId) {
      var element = document.getElementById(this.state.widgetId);

      if (element) {
        window.FastCommentsUserActivity(element, _extends({}, this.props), function (error, newInstance) {
          if (error) {
            console.error('FastComments User Activity Load Failure', error);
          } else {
            _this4.lastWidgetInstance = newInstance;
          }
        });
      }
    }
  };

  _proto.render = function render() {
    return createElement("div", null, this.state.widgetId ? createElement("div", {
      id: this.state.widgetId
    }, this.state.status === LoadStatus$5.Error ? 'Oh no! The comments section could not be loaded.' : '') : '');
  };

  return FastCommentsUserActivityFeedWidget;
}(Component);
FastCommentsUserActivityFeedWidget.widgetLoader = new ScriptLoader();

export { FastCommentsAPINotificationObjectType, FastCommentsAPINotificationType, FastCommentsAPIUserDigestEmailFrequency, FastCommentsCollabChatWidget, FastCommentsCommentCountWidget, FastCommentsCommentWidget, FastCommentsImageChatWidget, FastCommentsLiveChatWidget, FastCommentsLocale, FastCommentsSiteType, FastCommentsUserActivityFeedWidget, NotificationObjectType, NotificationType, TenantPaymentFrequency, VoteStyle };
//# sourceMappingURL=index.modern.js.map
